import { render, staticRenderFns } from "./AddAccountingYear.vue?vue&type=template&id=2703bbb3&scoped=true"
import script from "./AddAccountingYear.vue?vue&type=script&lang=js"
export * from "./AddAccountingYear.vue?vue&type=script&lang=js"
import style0 from "./AddAccountingYear.vue?vue&type=style&index=0&id=2703bbb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2703bbb3",
  null
  
)

export default component.exports